import { styled as e } from "./styled2.mjs";
const n = e("div")`
	display: flex;
	align-items: center;
`, t = e("div")`
	display: flex;
	margin-left: ${({ theme: i }) => i.spacing(1)};
`;
export {
  t as InformerContainer,
  n as LabelWrapper
};
//# sourceMappingURL=styles27.mjs.map
